// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__3SgGS","circular":"Loading_circular__NsSD5","rotate":"Loading_rotate__1Hy3U","circle-dash":"Loading_circle-dash__2VLTi"};